import { useHistory } from 'react-router-dom';

export default function useNavigate() {
  const history = useHistory();

  return function navigate(to) {
    history.push(to);
  };
}
